import {DoctorDataModel} from '../../../../models/doctors/doctor-data.model';

export class DoctorSaveValidationModel {
  doctor: DoctorDataModel;

  isWorkAddressExists = false;
  isWorkAddressStateExists = false;
  isWorkAddressCityExists = false;
  isWorkAddressZipExists = false;

  isCommRecordExists = false;
  isCommPhoneNumberExists = false;
  isCommMethodPreferredExists = false;

  isSpecialtyExists = false;
}
